/**
 * Utilitários para manipulação de bairros no frontend
 */

/**
 * Normaliza um nome de bairro removendo acentos e convertendo para maiúsculas
 */
export function normalizarBairro(bairro) {
  if (!bairro || typeof bairro !== 'string') {
    return '';
  }
  return bairro.trim().toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ''); // Remove acentos
}

/**
 * Busca taxa de entrega para um bairro específico
 */
export function buscarTaxaPorBairro(bairro, taxasPorBairro = [], taxaPadrao = 0) {
  if (!bairro || !taxasPorBairro || taxasPorBairro.length === 0) {
    return {
      taxa: taxaPadrao,
      encontrado: false,
      bairroEncontrado: null
    };
  }

  const bairroNormalizado = normalizarBairro(bairro);
  
  // Primeiro: busca exata (case insensitive, sem acentos)
  let taxaBairro = taxasPorBairro.find(t => {
    if (!t.bairro) return false;
    return normalizarBairro(t.bairro) === bairroNormalizado;
  });

  // Se não encontrar exata, busca parcial (inclui/contém)
  if (!taxaBairro) {
    taxaBairro = taxasPorBairro.find(t => {
      if (!t.bairro) return false;
      const bairroTaxaNormalizado = normalizarBairro(t.bairro);
      return bairroTaxaNormalizado.includes(bairroNormalizado) ||
             bairroNormalizado.includes(bairroTaxaNormalizado);
    });
  }

  if (taxaBairro) {
    return {
      taxa: Number(taxaBairro.taxa) || 0,
      encontrado: true,
      bairroEncontrado: taxaBairro.bairro
    };
  }

  return {
    taxa: taxaPadrao,
    encontrado: false,
    bairroEncontrado: null
  };
}



